const map = {
	"./pastEvents2011.json": 48610,
	"./pastEvents2012.json": 72915,
	"./pastEvents2013.json": 60272,
	"./pastEvents2014.json": 74457,
	"./pastEvents2015.json": 55870,
	"./pastEvents2016.json": 13727,
	"./pastEvents2017.json": 99884,
	"./pastEvents2018.json": 27877,
	"./pastEvents2019.json": 21818,
	"./pastEvents2020.json": 91430,
	"./pastEvents2021.json": 19233,
	"./pastEvents2022.json": 95316,
	"./pastEvents2023.json": 43623,
	"./pastEvents2024.json": 86634,
	"./pastEvents2025.json": 43509,
	"./pastEvents2026.json": 38648
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	const id = map[req];
	return __webpack_require__.t(id, 3 | 16);
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 86333;
module.exports = webpackAsyncContext;